import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import {
  Grid,
  Tooltip,
  Switch
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { withStyles } from "@material-ui/core/styles";
import UserEdit from './userUpdateModalForm';
import { updateUserInternal, getUserById } from "../../actions/user-actions";
import { DataContext } from "../../context/reducers/contextSearchUser";
import moment from "moment";
import { FlippedOrderExpansionPanelSummary } from "../../utils/functionsUtils";

const useStyles = makeStyles((theme) => ({
  MuiIconButtonEdgeEnd: {
    order: "-1",
  },
  root: {
    width: "100%",
    marginTop: "10px",
    marginLeft: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
    wordBreak: 'break-all'
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
    wordBreak: 'break-all'

  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "39.6%",
  },
  columnEvent: {
    paddingLeft: "20px",
    flexBasis: "33.33%",
    display: "flex",
    alignItems: "center"
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.white,
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: 'green',
        borderColor: 'green',
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.white}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.secondary.main,
  },
  checked: {},
}))(Switch);

export default function TableUser({
  headers,
  data,
  charges,
  setMessage,
  message,
  refresh,
  handleClickReset
}) {
  const {openEdit, setOpenEdit} = useContext(DataContext);
  const classes = useStyles();
  const id = IdKey.generate();
  const [checked, setChecked] = React.useState(false);
  const [idEdit, setIdEdit] = useState(0);
  const [dataRoles, setDataRoles] = useState([]);


  const arrayRoles = ( separador)=> {
    var array = [];
    for (const key in dataRoles) {
      if (dataRoles.hasOwnProperty(key)) {
        array.push(dataRoles[key]);
      }
    }
    return array.map(x => x.name).join(separador || ", ");
  }

  const getValueByKey = (object, header) => {
    if(header.field === 'status') {
      return data[header.field].toLowerCase()
      .split(" ")
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
    }
    if(header.field === 'type'){
      return data?.type.toLowerCase()
        .split(" ")
        .map(word => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
    }
    if(header.field === 'domainGender'){
      if(data?.person?.domainGender === null){
        return;
      }else{
        return data?.person?.domainGender.toLowerCase()
          .split(" ")
          .map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1);
          })
      }
    }
    if(header.field === 'dateBirth'){
      let fecha = data?.person?.dateBirth;
      let dateBirth = moment(fecha).format('DD/MM/YYYY');
      return dateBirth;
    }
    if(header.field === "roles"){
      return arrayRoles();
    }
    if (header.child === null) {
      if (header.field === "username") {
        return data?.username
      }
      if (header?.field === "password") {
        return <div>***********</div>
      }
      if (header.field) {
       
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (item) {
            result +=`${object[item] ?? '' } `;
          });
          return result;
        }
        return object[header.field];
      }
      return "";
    }
    return object[header.field] !== null
      ? object[header.field][header.child]
      : "";
  };

  useEffect(() => {
    setDataRoles(data?.roles);
  }, [data.roles])

  const infoDataUserId = () => {
    setIdEdit(data?.id);
    JSON.stringify( setOpenEdit(!openEdit));
  }

  const toggleChecked = (data) => {
    setMessage({
      description: data?.status?.toUpperCase() === 'ACTIVO' ? '¿Está seguro que desea inactivar el Usuario?' : '¿Está seguro que desea activar el Usuario?',
      textButtonSubmit: 'Aceptar',
      handleClick: () => changeStatusRol(data, data?.status),
      handleClickOut: () => handleClickOut(),
      type: 'QUESTION',
      open: true
    });
  };

  const handleClickOut = () => { setMessage({ ...message, open: false }); };
  const handleClick = () => {
    setMessage({ ...message, open: false }); setChecked((prev) => !prev);
    refresh();
    setOpenEdit(false)
  };

  const changeStatusRol = async (data, status) => {
    const response = await getUserById(data.id);
    if (response.status === 200 && response.status < 399) {
      
      const infoExternalUser = {
        id: response?.data?.id,
        firstName: response?.data?.person?.firstName,
        secondName: response?.data?.person?.secondName,
        surname: response?.data?.person?.surname,
        dateBirth: moment(response?.data?.person.dateBirth).format("YYYY-MM-DDTHH:mm"),  
        secondSurname: response?.data?.person?.secondSurname,
        cellPhoneNumber: response?.data?.person?.cellPhoneNumber,
        documentNumber: response?.data?.person?.documentNumber,
        documentType: response?.data?.person?.documentType,
        externalEmail: response?.data?.person?.externalEmail,
        internalEmail: response?.data?.person?.internalEmail,
        type: response?.data?.type,
        phone: response?.data?.person?.phone,
        gender: response?.data?.person?.domainGender,
        password: response?.data.validatePassword ? response?.data?.validatePassword : null,
        cargoId: response?.data?.person?.charge?.id,
        personId: response?.data?.person?.id,
        status: status?.toUpperCase() === "ACTIVO" ? "INACTIVO" : "ACTIVO",
        roleList: response?.data?.roleList.length ? response?.data?.roleList?.map(function (item) {
          return item['id'];
        }) : ''
      }

      const updateStateUser = await updateUserInternal(infoExternalUser);

      if (updateStateUser?.status >= 200 && updateStateUser?.status < 399) {
        refresh();
        setMessage({
          description: data?.status?.toUpperCase() === 'ACTIVO' ? `Usuario inactivado exitosamente` : `Usuario activado exitosamente`,
          textButtonSubmit: 'Aceptar',
          handleClick: () => handleClick(),
          type: 'SUCCESS',
          oneButtons: true,
          open: true
        });
      } else if (updateStateUser?.status > 399 && updateStateUser?.status !==401 && updateStateUser?.status !== 403) {
        setMessage({
          description: updateStateUser?.data?.detail,
          textButtonSubmit: 'ACEPTAR',
          handleClick: () => handleClickOut(),
          oneButtons: true,
          type: 'WARNING',
          open: true
        })
      } else {
        setMessage({
          description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
          textButtonSubmit: 'ACEPTAR',
          handleClick: () => handleClickOut(),
          oneButtons: true,
          type: 'WARNING',
          open: true
        })
      }

    }
  };

  return (
    <div className={classes.root}>
      <Accordion
        style={{ borderLeftStyle: "solid", borderLeftColor: '#F8DF13' }}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
          expandIcon={<ExpandMoreIcon style={{ pointerEvents: 'auto' }}
          />}
          style={{ pointerEvents: 'none' }}
        >
          {headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header?.title}
              </Typography>
              <Typography className={classes.secondaryHeading}>
                {getValueByKey(data.person, header)}
              </Typography>
            </div>
          ))}
          <div className={classes.columnEvent}>
            <Tooltip title="Ver detalle" arrow placement="top">
              <VisibilityIcon style={{ fontSize: 40, pointerEvents: 'auto' }} className={classes.iconEvent} />
            </Tooltip>
            &nbsp;&nbsp;
            <Tooltip title="Editar" arrow placement="top">
              <EditIcon
                style={{ fontSize: 40, pointerEvents: 'auto' }}
                onClick={ infoDataUserId}
                className={classes.iconEvent}
              />
            </Tooltip>
            &nbsp;&nbsp;
            {data?.type === "INTERNO" ? <Tooltip title={data?.status?.toUpperCase() === "ACTIVO" ? "ACTIVO" : 'INACTIVO'} arrow placement="top">
              <AntSwitch
                style={{ fontSize: 40, pointerEvents: 'auto' }}
                checked={data.status === "ACTIVO" ? true : false}
                onClick={(event) => { event.stopPropagation(); toggleChecked(data) }}
                onFocus={(event) => event.stopPropagation()}
              />
            </Tooltip> : null }
          </div>
        </FlippedOrderExpansionPanelSummary>
        <AccordionDetails className={classes.details}>
          {openEdit ?
            <UserEdit
              refresh = {refresh}
              setOpenEdit={setOpenEdit}
              userId={data.id}
              charges={charges}
              setMessage={setMessage}
              message={message}
              handleClickReset={handleClickReset}
              ExpandMoreIcon={ExpandMoreIcon}
            />

            : (
              <div className={classes.rootGrid}>
                <Grid container spacing={3} style={{ margin: '0px 20px' }}>
                  {headers?.otherHeaders?.map((header) => (
                    <Grid item xs={2}>
                      <Typography className={classes.heading}>
                        {header.title}
                      </Typography>
                      <Typography className={classes.secondaryHeading}>
                        {getValueByKey(data?.person, header)}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </div>
            )
          }
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
